<template>
  <div>
    <v-autocomplete
      v-model="selectedItem"
      class="font-13"
      :items="naverSearchResult"
      item-text="title"
      item-value="title"
      placeholder="업체명을 입력해주세요."
      no-data-text="검색 결과가 없습니다."
      :auto-select-first="true"
      @update:search-input="searchStore"
      outlined
      hide-details
      dense
      return-object
      height="40">
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-html="item.title"></v-list-item-title>
          <v-list-item-subtitle>{{ item.roadAddress }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-slot:no-data>
        <div v-if="isFetching">
          <v-skeleton-loader max-height="52" class="pa-4" type="paragraph"></v-skeleton-loader>
          <v-skeleton-loader max-height="52" class="pa-4" type="paragraph"></v-skeleton-loader>
          <v-skeleton-loader max-height="52" class="pa-4" type="paragraph"></v-skeleton-loader>
        </div>
        <v-list-item v-else-if="!isFetching && searchText.length > 0" @click="handleManualInput">
          <v-list-item-content>
            <v-list-item-title>직접 입력: "{{ searchText }}"</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NaverAutoComplete',
  data() {
    return {
      naverSearchResult: this.companyName ? [{ title: this.companyName, mapx: this.x, mapy: this.y }] : [],
      isFetching: false,
      searchText: '',
    };
  },
  props: {
    companyName: {
      type: String,
      required: true,
    },
    x: {
      type: String,
    },
    y: {
      type: String,
    },
    roadAddress: {
      type: String,
    },
  },
  computed: {
    selectedItem: {
      get() {
        return {
          title: this.companyName,
          x: this.x,
          y: this.y,
          roadAddress: this.roadAddress,
        };
      },
      set(value) {
        this.$emit('update:companyName', value.title);
        this.$emit('update:x', value.mapx);
        this.$emit('update:y', value.mapy);
        this.$emit('update:roadAddress', value.roadAddress);
      },
    },
  },

  methods: {
    handleManualInput() {
      this.selectedItem = { title: this.searchText, mapx: '', mapy: '', roadAddress: '' };
      this.naverSearchResult = [{ title: this.searchText }];
    },
    searchStore(value) {
      clearTimeout(this.searchDebounceTimer);

      // NOTE: selectedItem을 빈 값으로 초기화하면, 이후에 null이 한 번 더 할당되어 null이 들어오는 경우는 따로 핸들링

      if (value == null) {
        return;
      }

      if (value.length === 0 || value.trim() === '') {
        this.selectedItem = { title: '', mapx: '', mapy: '', roadAddress: '' };
        this.searchText = '';
        this.naverSearchResult = [];
        return;
      }

      this.searchText = value;

      this.searchDebounceTimer = setTimeout(async () => {
        if (this.companyName === value) {
          return;
        }

        this.naverSearchResult = [];

        try {
          this.isFetching = true;
          const result = await axios
            .get(`/utils/search/local?q=${value}&display=5`, { loading: false })
            .then(res => {
              return res.data;
            })
            .catch(err => {
              console.log(err);
            });

          const formattedResult = result.data.items.map(item => ({
            ...item,
            title: item.title.replace(/<b>/g, '').replace(/<\/b>/g, '').replace(/&amp;/g, '&'),
          }));

          this.naverSearchResult = JSON.parse(JSON.stringify(formattedResult));
        } catch (err) {
          console.log(err);
        } finally {
          this.isFetching = false;
        }
      }, 500);
    },
  },
};
</script>

<style scoped>
@import '../../../assets/scss/typo.scss';

.v-select-list {
  width: 100%;
  max-width: 384px !important;
}
</style>
